import { translate } from "../../../../scripts/translate";
import * as TranslationsKeys from "../../../../scripts/locale/translationsKeys";
import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { dialogCancelButtonClassName, dialogConfirmationButtonClassName } from "../../../../scripts/dialogConstants";
import { postRequestAndWaitForJobCompletion } from "../../../../scripts/jobCompletion";
import { reloadWithTurbo } from "../../../../scripts/turboHelper";
import { PoisDetailStimulusModel } from "../../../../scripts/_generated/PoisDetailStimulusModel";

export default class DetailController extends BaseStimulusModelController<PoisDetailStimulusModel> {
    
    markTranslationAsReviewed(event) {
        const markTranslationAsReviewedUrl = this.modelValue.markTranslationAsReviewedUrl;
        const getJobUrl = this.modelValue.getJobUrl;
        const actionButton = $(event.currentTarget);

        bootbox.confirm({
            message: "Really confirm that the Place translation has been reviewed?",
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    markTranslationAsReviewedUrl,
                    undefined,
                    getJobUrl,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    });
            }
        });
    }

    markTranslationAsNotReviewed(event) {
        const markTranslationAsNotReviewedUrl = this.modelValue.markTranslationAsNotReviewedUrl;
        const getJobUrl = this.modelValue.getJobUrl;
        const actionButton = $(event.currentTarget);

        bootbox.confirm({
            message: "Really revert that the Place translation has been reviewed?",
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    markTranslationAsNotReviewedUrl,
                    undefined,
                    getJobUrl,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    });
            }
        });
    }

    publish(event) {
        const publishPoiUrl = this.modelValue.publishPoiUrl;
        const getJobUrl = this.modelValue.getJobUrl;
        const actionButton = $(event.currentTarget);

        bootbox.confirm({
            message: "Really publish the Place?",
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    publishPoiUrl,
                    undefined,
                    getJobUrl,
                    actionButton,
                    () => {
                        reloadWithTurbo(); // todo: reload just the POI item
                    });
            }
        });
    }
}
